export default "__VITE_ASSET__uhEQwAKc__"